export default __webpack_public_path__ + "static/media/75e96e3f493d1c505c3890c7df172378.geojson";